import type { NavItem } from "../types/content";

export const navItems: readonly NavItem[] = [
  { label: "首页", path: "/" },
  { label: "话题", path: "/topics" },
  { label: "发布", path: "/publish" },
  { label: "树洞", path: "/treehole" },
  { label: "我的", path: "/profile" },
];

export const mainRoutes = new Set(["/", "/topics", "/treehole", "/profile"]);
